<template>
    <div class="auth-layout">

        <!-- Panel izquierdo: Marca -->
        <div class="auth-brand">
            <div class="brand-content">
                <img src="@/assets/img/logo_login1.png" alt="ANW Logistics" class="brand-logo" />
                <h2 class="brand-title">Únete a ANW</h2>
                <p class="brand-sub">Crea tu cuenta y comienza a gestionar tus envíos de manera rápida y segura.</p>
                <div class="brand-steps">
                    <div class="brand-step">
                        <div class="step-num">1</div>
                        <span>Completa tus datos personales</span>
                    </div>
                    <div class="brand-step">
                        <div class="step-num">2</div>
                        <span>Tu cuenta será revisada y activada</span>
                    </div>
                    <div class="brand-step">
                        <div class="step-num">3</div>
                        <span>¡Comienza a gestionar tus envíos!</span>
                    </div>
                </div>
            </div>
            <div class="brand-deco deco-1"></div>
            <div class="brand-deco deco-2"></div>
        </div>

        <!-- Panel derecho: Formulario -->
        <div class="auth-form-panel">
            <div class="auth-form-inner">

                <div class="auth-form-header">
                    <img src="@/assets/img/logo_login1.png" alt="ANW" class="mobile-logo" />
                    <h3 class="auth-title">Crear cuenta</h3>
                    <p class="auth-sub">Completa el formulario para registrarte</p>
                </div>

                <form @submit.prevent="register">

                    <div class="field-row">
                        <div class="field-group">
                            <label class="field-label">Nombre</label>
                            <div class="field-input" :class="{ focused: focus.name }">
                                <i class="bi bi-person field-icon"></i>
                                <input type="text" v-model="form.name" placeholder="Tu nombre" required
                                    @focus="focus.name = true" @blur="focus.name = false" />
                            </div>
                        </div>
                        <div class="field-group">
                            <label class="field-label">Apellido</label>
                            <div class="field-input" :class="{ focused: focus.apellido }">
                                <i class="bi bi-person field-icon"></i>
                                <input type="text" v-model="form.apellido" placeholder="Tu apellido" required
                                    @focus="focus.apellido = true" @blur="focus.apellido = false" />
                            </div>
                        </div>
                    </div>

                    <div class="field-row">
                        <div class="field-group">
                            <label class="field-label">DNI</label>
                            <div class="field-input" :class="{ focused: focus.dni }">
                                <i class="bi bi-card-text field-icon"></i>
                                <input type="text" v-model="form.dni" placeholder="12345678" required maxlength="8"
                                    @focus="focus.dni = true" @blur="focus.dni = false" />
                            </div>
                        </div>
                        <div class="field-group">
                            <label class="field-label">Teléfono</label>
                            <div class="field-input" :class="{ focused: focus.telefono }">
                                <i class="bi bi-telephone field-icon"></i>
                                <input type="text" v-model="form.telefono" placeholder="987654321" required
                                    @focus="focus.telefono = true" @blur="focus.telefono = false" />
                            </div>
                        </div>
                    </div>

                    <div class="field-group">
                        <label class="field-label">Correo electrónico</label>
                        <div class="field-input" :class="{ focused: focus.email }">
                            <i class="bi bi-envelope field-icon"></i>
                            <input type="email" v-model="form.email" placeholder="tu@correo.com" required
                                @focus="focus.email = true" @blur="focus.email = false" />
                        </div>
                    </div>

                    <div class="field-row">
                        <div class="field-group">
                            <label class="field-label">Contraseña</label>
                            <div class="field-input" :class="{ focused: focus.pass }">
                                <i class="bi bi-lock field-icon"></i>
                                <input :type="showPassword ? 'text' : 'password'" v-model="form.password" placeholder="••••••••" required
                                    @focus="focus.pass = true" @blur="focus.pass = false" />
                                <button type="button" class="eye-btn" @click="showPassword = !showPassword">
                                    <i :class="showPassword ? 'bi bi-eye-slash' : 'bi bi-eye'"></i>
                                </button>
                            </div>
                        </div>
                        <div class="field-group">
                            <label class="field-label">Confirmar contraseña</label>
                            <div class="field-input" :class="{ focused: focus.passConf }">
                                <i class="bi bi-lock-fill field-icon"></i>
                                <input :type="showPasswordConfirmation ? 'text' : 'password'" v-model="form.password_confirmation" placeholder="••••••••" required
                                    @focus="focus.passConf = true" @blur="focus.passConf = false" />
                                <button type="button" class="eye-btn" @click="showPasswordConfirmation = !showPasswordConfirmation">
                                    <i :class="showPasswordConfirmation ? 'bi bi-eye-slash' : 'bi bi-eye'"></i>
                                </button>
                            </div>
                        </div>
                    </div>

                    <p v-if="error" class="auth-error"><i class="bi bi-exclamation-circle me-1"></i>{{ error }}</p>

                    <button type="submit" class="auth-btn" :disabled="loading">
                        <span v-if="loading" class="spinner-border spinner-border-sm me-2"></span>
                        <span v-else><i class="bi bi-person-plus me-2"></i></span>
                        {{ loading ? 'Registrando...' : 'Crear cuenta' }}
                    </button>

                    <p class="auth-link-row">¿Ya tienes una cuenta? <a href="/login">Iniciar sesión</a></p>
                </form>
            </div>
        </div>

    </div>
</template>

<script>
import axios from 'axios';

export default {
    name: 'RegisterPage',
    data() {
        return {
            form: {
                name: '',
                apellido: '',
                dni: '',
                email: '',
                telefono: '',
                cargo: 'externo',
                tipo_usuario: 'externo',
                empresa_id: 2,
                password: '',
                password_confirmation: ''
            },
            error: '',
            loading: false,
            showPassword: false,
            showPasswordConfirmation: false,
            focus: {
                name: false, apellido: false, dni: false,
                telefono: false, email: false, pass: false, passConf: false
            }
        };
    },
    methods: {
        async register() {
            this.loading = true;
            this.error = '';
            try {
                const response = await axios.post('/register', this.form);
                if (response.status === 201) {
                    this.$router.push('/login');
                } else {
                    this.error = 'Error en el registro.';
                }
            } catch (err) {
                this.error = err.response?.data?.error || 'Error en el registro.';
            } finally {
                this.loading = false;
            }
        }
    }
};
</script>

<style scoped>
/* ── Layout ── */
.auth-layout {
    display: flex;
    min-height: 100vh;
    width: 100vw;
    overflow: hidden;
}

/* ── Panel de Marca ── */
.auth-brand {
    flex: 0 0 40%;
    background: linear-gradient(145deg, #3f51b5 0%, #283593 60%, #1a237e 100%);
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
    overflow: hidden;
    padding: 48px 40px;
}
.brand-content {
    position: relative;
    z-index: 2;
    text-align: center;
    max-width: 320px;
}
.brand-logo {
    width: 160px;
    margin-bottom: 32px;
    filter: brightness(0) invert(1);
}
.brand-title {
    color: #fff;
    font-size: 1.6rem;
    font-weight: 800;
    margin-bottom: 12px;
}
.brand-sub {
    color: rgba(255,255,255,0.75);
    font-size: 0.9rem;
    line-height: 1.6;
    margin-bottom: 36px;
}
.brand-steps {
    display: flex;
    flex-direction: column;
    gap: 14px;
    text-align: left;
}
.brand-step {
    display: flex;
    align-items: center;
    gap: 14px;
    color: rgba(255,255,255,0.9);
    font-size: 0.86rem;
    font-weight: 500;
}
.step-num {
    width: 28px;
    height: 28px;
    border-radius: 50%;
    background: rgba(255,255,255,0.2);
    color: #fff;
    font-size: 0.8rem;
    font-weight: 800;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
    border: 1.5px solid rgba(255,255,255,0.4);
}
.brand-deco {
    position: absolute;
    border-radius: 50%;
    opacity: 0.08;
    background: #fff;
}
.deco-1 { width: 350px; height: 350px; top: -100px; right: -100px; }
.deco-2 { width: 250px; height: 250px; bottom: -80px; left: -60px; }

/* ── Panel formulario ── */
.auth-form-panel {
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: center;
    background: #f8f9ff;
    padding: 40px 24px;
    overflow-y: auto;
}
.auth-form-inner {
    width: 100%;
    max-width: 520px;
}

.mobile-logo {
    display: none;
    width: 110px;
    margin-bottom: 18px;
}

.auth-form-header { margin-bottom: 28px; }
.auth-title {
    font-size: 1.5rem;
    font-weight: 800;
    color: #1a237e;
    margin-bottom: 5px;
}
.auth-sub { color: #78909c; font-size: 0.88rem; }

/* ── Fila doble de campos ── */
.field-row {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 16px;
}

/* ── Campos ── */
.field-group { margin-bottom: 18px; }
.field-label {
    display: block;
    font-size: 0.76rem;
    font-weight: 700;
    color: #546e7a;
    text-transform: uppercase;
    letter-spacing: 0.4px;
    margin-bottom: 6px;
}
.field-input {
    display: flex;
    align-items: center;
    background: #fff;
    border: 1.5px solid #e0e0e0;
    border-radius: 10px;
    height: 46px;
    transition: border-color 0.2s, box-shadow 0.2s;
    overflow: hidden;
}
.field-input.focused {
    border-color: #3f51b5;
    box-shadow: 0 0 0 3px rgba(63,81,181,0.12);
}
.field-icon {
    padding: 0 12px;
    color: #9e9e9e;
    font-size: 0.95rem;
    flex-shrink: 0;
}
.field-input input {
    flex: 1;
    border: none;
    outline: none;
    background: transparent;
    font-size: 0.9rem;
    color: #212121;
    height: 100%;
    min-width: 0;
}
.field-input input::placeholder { color: #bdbdbd; }
.eye-btn {
    background: none;
    border: none;
    padding: 0 12px;
    cursor: pointer;
    color: #9e9e9e;
    font-size: 0.95rem;
    height: 100%;
    display: flex;
    align-items: center;
    flex-shrink: 0;
}
.eye-btn:hover { color: #3f51b5; }

/* ── Error ── */
.auth-error {
    background: #ffebee;
    color: #c62828;
    border-radius: 8px;
    padding: 10px 14px;
    font-size: 0.85rem;
    margin-bottom: 16px;
    border-left: 3px solid #c62828;
}

/* ── Botón principal ── */
.auth-btn {
    width: 100%;
    height: 48px;
    background: linear-gradient(135deg, #3f51b5 0%, #283593 100%);
    color: #fff;
    border: none;
    border-radius: 10px;
    font-size: 0.95rem;
    font-weight: 700;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 6px;
    transition: opacity 0.2s, transform 0.15s;
    margin-bottom: 20px;
}
.auth-btn:hover:not(:disabled) { opacity: 0.92; transform: translateY(-1px); }
.auth-btn:disabled { opacity: 0.65; cursor: not-allowed; }

.auth-link-row {
    text-align: center;
    font-size: 0.88rem;
    color: #78909c;
    margin: 0;
}
.auth-link-row a { color: #3f51b5; font-weight: 700; text-decoration: none; }
.auth-link-row a:hover { text-decoration: underline; }

/* ── Responsive ── */
@media (max-width: 768px) {
    .auth-brand { display: none; }
    .auth-form-panel {
        background: url('@/assets/img/peru-logistics-bg.png') no-repeat center center;
        background-size: cover;
        align-items: flex-start;
        padding: 20px 16px 40px;
    }
    .auth-form-inner {
        background: rgba(255,255,255,0.97);
        border-radius: 16px;
        padding: 28px 20px;
        box-shadow: 0 10px 40px rgba(0,0,0,0.15);
        margin-top: 30px;
    }
    .mobile-logo { display: block; }
    .auth-title { font-size: 1.25rem; }
    .field-row { grid-template-columns: 1fr; gap: 0; }
}
</style>
